"use strict";
/**
 * Error codes for Hermis Solana Headless SDK
 *
 * Organized into ranges:
 * - 1000-1999: Wallet Connection Errors
 * - 2000-2999: Wallet Interaction Errors
 * - 3000-3999: Transaction Errors
 * - 4000-4999: Network/RPC Errors
 * - 5000-5999: Signing Errors
 * - 6000-6999: Standard Wallet Errors
 * - 7000-7999: Kit Architecture Errors
 * - 8000-8999: Configuration Errors
 * - 9000-9999: Invariant Violations
 *
 * NOTE: These are constants, not enums, to enable tree-shaking
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.HERMIS_ERROR__STANDARD_WALLET__ACCOUNT_VALIDATION_FAILED = exports.HERMIS_ERROR__STANDARD_WALLET__CLUSTER_MISMATCH = exports.HERMIS_ERROR__STANDARD_WALLET__REGISTRATION_FAILED = exports.HERMIS_ERROR__STANDARD_WALLET__DETECTION_FAILED = exports.HERMIS_ERROR__STANDARD_WALLET__CHAIN_NOT_SUPPORTED = exports.HERMIS_ERROR__STANDARD_WALLET__ACCOUNT_CHANGE_FAILED = exports.HERMIS_ERROR__STANDARD_WALLET__ACCOUNT_NOT_FOUND = exports.HERMIS_ERROR__STANDARD_WALLET__METHOD_NOT_IMPLEMENTED = exports.HERMIS_ERROR__STANDARD_WALLET__FEATURE_NOT_FOUND = exports.HERMIS_ERROR__SIGNING__SIGNATURE_NOT_FOUND = exports.HERMIS_ERROR__SIGNING__PRIVATE_KEY_UNAVAILABLE = exports.HERMIS_ERROR__SIGNING__KEYPAIR_CONVERSION_FAILED = exports.HERMIS_ERROR__SIGNING__VERIFICATION_FAILED = exports.HERMIS_ERROR__SIGNING__INVALID_SIGNATURE = exports.HERMIS_ERROR__SIGNING__ALL_TRANSACTIONS_FAILED = exports.HERMIS_ERROR__SIGNING__TRANSACTION_FAILED = exports.HERMIS_ERROR__SIGNING__MESSAGE_FAILED = exports.HERMIS_ERROR__NETWORK__RATE_LIMIT_EXCEEDED = exports.HERMIS_ERROR__NETWORK__INSUFFICIENT_BALANCE = exports.HERMIS_ERROR__NETWORK__ACCOUNT_NOT_FOUND = exports.HERMIS_ERROR__NETWORK__AIRDROP_FAILED = exports.HERMIS_ERROR__NETWORK__BLOCKHASH_UNAVAILABLE = exports.HERMIS_ERROR__NETWORK__CONNECTION_FAILED = exports.HERMIS_ERROR__NETWORK__RPC_REQUEST_FAILED = exports.HERMIS_ERROR__TRANSACTION__BATCH_SIGNING_NOT_IMPLEMENTED = exports.HERMIS_ERROR__TRANSACTION__DESERIALIZATION_FAILED = exports.HERMIS_ERROR__TRANSACTION__VERSION_NOT_SUPPORTED = exports.HERMIS_ERROR__TRANSACTION__INVALID_TYPE = exports.HERMIS_ERROR__TRANSACTION__SIMULATION_FAILED = exports.HERMIS_ERROR__TRANSACTION__CONFIRMATION_FAILED = exports.HERMIS_ERROR__TRANSACTION__ENCODING_FAILED = exports.HERMIS_ERROR__TRANSACTION__COMPILATION_FAILED = exports.HERMIS_ERROR__TRANSACTION__SERIALIZATION_FAILED = exports.HERMIS_ERROR__TRANSACTION__FEE_PAYER_MISSING = exports.HERMIS_ERROR__TRANSACTION__SIGNATURES_MISSING = exports.HERMIS_ERROR__TRANSACTION__SEND_FAILED = exports.HERMIS_ERROR__TRANSACTION__SIGNATURE_FAILED = exports.HERMIS_ERROR__WALLET_INTERACTION__FEATURE_NOT_SUPPORTED = exports.HERMIS_ERROR__WALLET_INTERACTION__TIMEOUT = exports.HERMIS_ERROR__WALLET_INTERACTION__USER_REJECTED_SIGNATURE = exports.HERMIS_ERROR__WALLET_INTERACTION__USER_REJECTED_TRANSACTION = exports.HERMIS_ERROR__WALLET_INTERACTION__USER_REJECTED_CONNECTION = exports.HERMIS_ERROR__WALLET_CONNECTION__NO_PUBLIC_KEY = exports.HERMIS_ERROR__WALLET_CONNECTION__AUTO_CONNECT_FAILED = exports.HERMIS_ERROR__WALLET_CONNECTION__UNSUPPORTED = exports.HERMIS_ERROR__WALLET_CONNECTION__NOT_READY = exports.HERMIS_ERROR__WALLET_CONNECTION__DISCONNECT_FAILED = exports.HERMIS_ERROR__WALLET_CONNECTION__FAILED = exports.HERMIS_ERROR__WALLET_CONNECTION__NOT_CONNECTED = exports.HERMIS_ERROR__WALLET_CONNECTION__NO_WALLET_SELECTED = void 0;
exports.HERMIS_ERROR__INVARIANT__TYPE_MISMATCH = exports.HERMIS_ERROR__INVARIANT__OPERATION_NOT_ALLOWED = exports.HERMIS_ERROR__INVARIANT__INVALID_ARGUMENT = exports.HERMIS_ERROR__INVARIANT__NULL_VALUE = exports.HERMIS_ERROR__INVARIANT__UNEXPECTED_STATE = exports.HERMIS_ERROR__REACT__INVALID_PROVIDER_CONFIG = exports.HERMIS_ERROR__REACT__CONTEXT_NOT_FOUND = exports.HERMIS_ERROR__STORAGE__WRITE_FAILED = exports.HERMIS_ERROR__STORAGE__READ_FAILED = exports.HERMIS_ERROR__STORAGE__LOCALSTORAGE_FAILED = exports.HERMIS_ERROR__STORAGE__INDEXEDDB_FAILED = exports.HERMIS_ERROR__CONFIG__STORAGE_INIT_FAILED = exports.HERMIS_ERROR__CONFIG__INVALID_ADAPTER = exports.HERMIS_ERROR__CONFIG__INVALID_RPC_ENDPOINT = exports.HERMIS_ERROR__CONFIG__MISSING_REQUIRED = exports.HERMIS_ERROR__CONFIG__INVALID_CONFIGURATION = exports.HERMIS_ERROR__KIT__REQUIRES_CONNECTION = exports.HERMIS_ERROR__KIT__INVALID_WALLET_TYPE = exports.HERMIS_ERROR__KIT__LEGACY_CONVERSION_FAILED = exports.HERMIS_ERROR__KIT__CANNOT_SIGN_WITH_ADDRESS = exports.HERMIS_ERROR__KIT__LEGACY_MODE_INCOMPATIBLE = exports.HERMIS_ERROR__KIT__DECODER_NOT_AVAILABLE = exports.HERMIS_ERROR__KIT__ENCODER_NOT_AVAILABLE = exports.HERMIS_ERROR__KIT__MESSAGE_COMPILATION_FAILED = exports.HERMIS_ERROR__KIT__RPC_CONNECTION_FAILED = void 0;
// ============================================
// 1000-1999: Wallet Connection Errors
// ============================================
/** No wallet adapter has been selected */
exports.HERMIS_ERROR__WALLET_CONNECTION__NO_WALLET_SELECTED = 1000;
/** Wallet is not connected */
exports.HERMIS_ERROR__WALLET_CONNECTION__NOT_CONNECTED = 1001;
/** Wallet connection failed */
exports.HERMIS_ERROR__WALLET_CONNECTION__FAILED = 1002;
/** Wallet disconnection failed */
exports.HERMIS_ERROR__WALLET_CONNECTION__DISCONNECT_FAILED = 1003;
/** Wallet is not ready (not installed or not loaded) */
exports.HERMIS_ERROR__WALLET_CONNECTION__NOT_READY = 1004;
/** Wallet is not supported on this platform */
exports.HERMIS_ERROR__WALLET_CONNECTION__UNSUPPORTED = 1005;
/** Auto-connect failed */
exports.HERMIS_ERROR__WALLET_CONNECTION__AUTO_CONNECT_FAILED = 1006;
/** Wallet public key is not available */
exports.HERMIS_ERROR__WALLET_CONNECTION__NO_PUBLIC_KEY = 1007;
// ============================================
// 2000-2999: Wallet Interaction Errors
// ============================================
/** User rejected the connection request */
exports.HERMIS_ERROR__WALLET_INTERACTION__USER_REJECTED_CONNECTION = 2000;
/** User rejected the transaction */
exports.HERMIS_ERROR__WALLET_INTERACTION__USER_REJECTED_TRANSACTION = 2001;
/** User rejected the signature request */
exports.HERMIS_ERROR__WALLET_INTERACTION__USER_REJECTED_SIGNATURE = 2002;
/** Wallet operation timed out */
exports.HERMIS_ERROR__WALLET_INTERACTION__TIMEOUT = 2003;
/** Wallet does not support the requested feature */
exports.HERMIS_ERROR__WALLET_INTERACTION__FEATURE_NOT_SUPPORTED = 2004;
// ============================================
// 3000-3999: Transaction Errors
// ============================================
/** Transaction signature failed */
exports.HERMIS_ERROR__TRANSACTION__SIGNATURE_FAILED = 3000;
/** Transaction send failed */
exports.HERMIS_ERROR__TRANSACTION__SEND_FAILED = 3001;
/** Transaction is missing required signatures */
exports.HERMIS_ERROR__TRANSACTION__SIGNATURES_MISSING = 3002;
/** Transaction fee payer is missing */
exports.HERMIS_ERROR__TRANSACTION__FEE_PAYER_MISSING = 3003;
/** Transaction serialization failed */
exports.HERMIS_ERROR__TRANSACTION__SERIALIZATION_FAILED = 3004;
/** Transaction compilation failed (Kit architecture) */
exports.HERMIS_ERROR__TRANSACTION__COMPILATION_FAILED = 3005;
/** Transaction encoding failed (Kit architecture) */
exports.HERMIS_ERROR__TRANSACTION__ENCODING_FAILED = 3006;
/** Transaction confirmation failed */
exports.HERMIS_ERROR__TRANSACTION__CONFIRMATION_FAILED = 3007;
/** Transaction simulation failed */
exports.HERMIS_ERROR__TRANSACTION__SIMULATION_FAILED = 3008;
/** Invalid transaction type */
exports.HERMIS_ERROR__TRANSACTION__INVALID_TYPE = 3009;
/** Wallet doesn't support transaction version */
exports.HERMIS_ERROR__TRANSACTION__VERSION_NOT_SUPPORTED = 3010;
/** Transaction deserialization failed */
exports.HERMIS_ERROR__TRANSACTION__DESERIALIZATION_FAILED = 3011;
/** Batch transaction signing not yet implemented */
exports.HERMIS_ERROR__TRANSACTION__BATCH_SIGNING_NOT_IMPLEMENTED = 3012;
// ============================================
// 4000-4999: Network/RPC Errors
// ============================================
/** RPC request failed */
exports.HERMIS_ERROR__NETWORK__RPC_REQUEST_FAILED = 4000;
/** Network connection failed */
exports.HERMIS_ERROR__NETWORK__CONNECTION_FAILED = 4001;
/** Failed to get recent blockhash */
exports.HERMIS_ERROR__NETWORK__BLOCKHASH_UNAVAILABLE = 4002;
/** Airdrop request failed */
exports.HERMIS_ERROR__NETWORK__AIRDROP_FAILED = 4003;
/** Account not found on-chain */
exports.HERMIS_ERROR__NETWORK__ACCOUNT_NOT_FOUND = 4004;
/** Insufficient SOL balance */
exports.HERMIS_ERROR__NETWORK__INSUFFICIENT_BALANCE = 4005;
/** Rate limit exceeded */
exports.HERMIS_ERROR__NETWORK__RATE_LIMIT_EXCEEDED = 4006;
// ============================================
// 5000-5999: Signing Errors
// ============================================
/** Message signing failed */
exports.HERMIS_ERROR__SIGNING__MESSAGE_FAILED = 5000;
/** Transaction signing failed */
exports.HERMIS_ERROR__SIGNING__TRANSACTION_FAILED = 5001;
/** Multiple transaction signing failed */
exports.HERMIS_ERROR__SIGNING__ALL_TRANSACTIONS_FAILED = 5002;
/** Invalid signature format */
exports.HERMIS_ERROR__SIGNING__INVALID_SIGNATURE = 5003;
/** Signature verification failed */
exports.HERMIS_ERROR__SIGNING__VERIFICATION_FAILED = 5004;
/** CryptoKeyPair to Keypair conversion failed */
exports.HERMIS_ERROR__SIGNING__KEYPAIR_CONVERSION_FAILED = 5010;
/** Cannot sign with Address (no private key available) */
exports.HERMIS_ERROR__SIGNING__PRIVATE_KEY_UNAVAILABLE = 5011;
/** No signature found for signer address */
exports.HERMIS_ERROR__SIGNING__SIGNATURE_NOT_FOUND = 5012;
// ============================================
// 6000-6999: Standard Wallet Errors
// ============================================
/** Standard wallet feature not found */
exports.HERMIS_ERROR__STANDARD_WALLET__FEATURE_NOT_FOUND = 6000;
/** Standard wallet method not implemented */
exports.HERMIS_ERROR__STANDARD_WALLET__METHOD_NOT_IMPLEMENTED = 6001;
/** Standard wallet account not found */
exports.HERMIS_ERROR__STANDARD_WALLET__ACCOUNT_NOT_FOUND = 6002;
/** Standard wallet account change detection failed */
exports.HERMIS_ERROR__STANDARD_WALLET__ACCOUNT_CHANGE_FAILED = 6003;
/** Standard wallet chain not supported */
exports.HERMIS_ERROR__STANDARD_WALLET__CHAIN_NOT_SUPPORTED = 6004;
/** Wallet detection failed */
exports.HERMIS_ERROR__STANDARD_WALLET__DETECTION_FAILED = 6010;
/** Wallet registration failed */
exports.HERMIS_ERROR__STANDARD_WALLET__REGISTRATION_FAILED = 6011;
/** Cluster mismatch between wallet and transaction */
exports.HERMIS_ERROR__STANDARD_WALLET__CLUSTER_MISMATCH = 6012;
/** Account validation failed */
exports.HERMIS_ERROR__STANDARD_WALLET__ACCOUNT_VALIDATION_FAILED = 6013;
// ============================================
// 7000-7999: Kit Architecture Errors
// ============================================
/** Kit RPC connection failed */
exports.HERMIS_ERROR__KIT__RPC_CONNECTION_FAILED = 7000;
/** Kit transaction message compilation failed */
exports.HERMIS_ERROR__KIT__MESSAGE_COMPILATION_FAILED = 7001;
/** Kit encoder not available */
exports.HERMIS_ERROR__KIT__ENCODER_NOT_AVAILABLE = 7002;
/** Kit decoder not available */
exports.HERMIS_ERROR__KIT__DECODER_NOT_AVAILABLE = 7003;
/** Kit feature not supported in legacy mode */
exports.HERMIS_ERROR__KIT__LEGACY_MODE_INCOMPATIBLE = 7004;
/** Cannot sign with Address type */
exports.HERMIS_ERROR__KIT__CANNOT_SIGN_WITH_ADDRESS = 7010;
/** Kit to legacy conversion failed */
exports.HERMIS_ERROR__KIT__LEGACY_CONVERSION_FAILED = 7011;
/** Invalid wallet type for operation */
exports.HERMIS_ERROR__KIT__INVALID_WALLET_TYPE = 7012;
/** Kit operation requires connection parameter */
exports.HERMIS_ERROR__KIT__REQUIRES_CONNECTION = 7013;
// ============================================
// 8000-8999: Configuration Errors
// ============================================
/** Invalid configuration provided */
exports.HERMIS_ERROR__CONFIG__INVALID_CONFIGURATION = 8000;
/** Required configuration missing */
exports.HERMIS_ERROR__CONFIG__MISSING_REQUIRED = 8001;
/** Invalid RPC endpoint */
exports.HERMIS_ERROR__CONFIG__INVALID_RPC_ENDPOINT = 8002;
/** Invalid adapter configuration */
exports.HERMIS_ERROR__CONFIG__INVALID_ADAPTER = 8003;
/** Storage utility initialization failed */
exports.HERMIS_ERROR__CONFIG__STORAGE_INIT_FAILED = 8004;
/** IndexedDB operation failed */
exports.HERMIS_ERROR__STORAGE__INDEXEDDB_FAILED = 8010;
/** LocalStorage operation failed */
exports.HERMIS_ERROR__STORAGE__LOCALSTORAGE_FAILED = 8011;
/** Storage read operation failed */
exports.HERMIS_ERROR__STORAGE__READ_FAILED = 8012;
/** Storage write operation failed */
exports.HERMIS_ERROR__STORAGE__WRITE_FAILED = 8013;
/** React hook used outside of provider context */
exports.HERMIS_ERROR__REACT__CONTEXT_NOT_FOUND = 8020;
/** Invalid React provider configuration */
exports.HERMIS_ERROR__REACT__INVALID_PROVIDER_CONFIG = 8021;
// ============================================
// 9000-9999: Invariant Violations
// ============================================
/** Invariant violation: unexpected state */
exports.HERMIS_ERROR__INVARIANT__UNEXPECTED_STATE = 9000;
/** Invariant violation: null or undefined value */
exports.HERMIS_ERROR__INVARIANT__NULL_VALUE = 9001;
/** Invariant violation: invalid argument */
exports.HERMIS_ERROR__INVARIANT__INVALID_ARGUMENT = 9002;
/** Invariant violation: operation not allowed */
exports.HERMIS_ERROR__INVARIANT__OPERATION_NOT_ALLOWED = 9003;
/** Invariant violation: type mismatch */
exports.HERMIS_ERROR__INVARIANT__TYPE_MISMATCH = 9004;
